import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import { EpicSection, SectionHeader } from '@/vdp/styles';
import CarCompareGrid from '@/vdp/VehiclesYouMightLike/CarCompareGrid';
import { totalVehiclesGrid } from '@/vdp/VehiclesYouMightLike/constants';
import VehiclesYouMightLikeLoader from '@/vdp/VehiclesYouMightLike/VehiclesYouMightLikeLoader';
import { initialRecommendedVehicles } from '~/constants/initialRecommendedVehicles';
import Sections from '~/constants/sections';
import { useGetRecommendations } from '~/hooks/vdp/services';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const CarCompareLite = () => {
  const { trackEvent } = useContext(AnalyticsContext);
  const { error, isLoaded, vehicles } = useGetRecommendations(
    totalVehiclesGrid,
    true
  );

  useEffect(() => {
    if (vehicles.length > 0) {
      trackEvent('recommended-vehicles-shown', {
        vehiclesShown: vehicles.map(vehicle => vehicle.vehicleId)
      });
    }
  }, [trackEvent, vehicles]);

  if (error || (isLoaded && !vehicles.length)) return null;

  return (
    <EpicSection
      id={Sections.VehiclesYouMightLike}
      threshold={1 / initialRecommendedVehicles}
    >
      <SectionHeader>Recommended For You</SectionHeader>
      {isLoaded ? (
        <CarCompareGrid vehicles={vehicles} />
      ) : (
        <VehiclesYouMightLikeLoader showLoadMore />
      )}
    </EpicSection>
  );
};

export default withErrorBoundary(
  CarCompareLite,
  undefined,
  undefined,
  Sections.VehiclesYouMightLike
);
